import { useState } from 'react';
import { PASSWORD_MIN } from '@kia/shared';
import { api, errMsg } from '../api/client';
import { Button, Field, Input, Modal, useToast } from '../ui';

/** Self-service password change — any logged-in user can rotate their own credential (POST /api/me/password). */
export function ChangePasswordModal({ onClose }: { onClose: () => void }) {
  const toast = useToast();
  const [oldPassword, setOld] = useState('');
  const [newPassword, setNew] = useState('');
  const [confirmNew, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit() {
    setError('');
    if (newPassword.length < PASSWORD_MIN)
      return setError(`گذرواژهٔ جدید حداقل ${PASSWORD_MIN} نویسه`);
    if (newPassword !== confirmNew) return setError('گذرواژهٔ جدید و تکرار آن یکسان نیستند');
    setBusy(true);
    const r = await api('/api/me/password', {
      method: 'POST',
      body: JSON.stringify({ oldPassword, newPassword }),
    });
    setBusy(false);
    if (r.status === 401) return setError('گذرواژهٔ فعلی نادرست است');
    if (!r.ok) return setError(errMsg(r));
    toast('گذرواژه تغییر کرد');
    onClose();
  }

  return (
    <Modal
      title="تغییر گذرواژه"
      onClose={onClose}
      actions={
        <>
          <Button variant="secondary" onClick={onClose}>
            انصراف
          </Button>
          <Button onClick={submit} loading={busy}>
            ذخیره
          </Button>
        </>
      }
    >
      <div className="form-grid">
        <Field label="گذرواژهٔ فعلی">
          <Input
            type="password"
            value={oldPassword}
            onChange={(e) => setOld(e.target.value)}
            autoComplete="current-password"
          />
        </Field>
        <Field label="گذرواژهٔ جدید" hint={`حداقل ${PASSWORD_MIN} نویسه`}>
          <Input
            type="password"
            value={newPassword}
            onChange={(e) => setNew(e.target.value)}
            autoComplete="new-password"
          />
        </Field>
        <Field label="تکرار گذرواژهٔ جدید">
          <Input
            type="password"
            value={confirmNew}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
          />
        </Field>
      </div>
      {error ? <div className="field-error">{error}</div> : null}
    </Modal>
  );
}
